import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { Event as ScheduleIcon } from '@mui/icons-material';

function SessionSchedulingWidget() {
  return (
    <Card>
      <CardContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          py={3}
        >
          <ScheduleIcon color="disabled" sx={{ fontSize: 48, mb: 2 }} />
          <Typography variant="h6" fontWeight="bold" color="text.secondary" gutterBottom>
            Session Scheduling
          </Typography>
          <Typography variant="body2" color="text.disabled" textAlign="center">
            Session scheduling feature coming soon.
            <br />
            This will allow you to manage and schedule therapy sessions with clients.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

export default SessionSchedulingWidget;
